import request from '@/utils/request'
import { btcguid } from '@/utils/validate'
import { getToken } from '@/utils/auth'

export function uploadReportFile(params) {
  const formData = new FormData()
  formData.append('MessageType', 2000000002)
  formData.append('MessageID', btcguid())
  formData.append('Files', params.Files)
  formData.append('Type', params.Type)
  return request({
    url: '/UploadBtcReport',
    method: 'post',
    headers: {
      'Authorization': getToken()
    },
    data: formData
  })
}

export function getBtcReportList(params) {
  return request({
    url: '/GetBtcReportList',
    method: 'post',
    headers: {
      'Authorization': getToken()
    },
    data: {
      MessageType: 2000000001,
      MessageID: btcguid(),
      Data: {
        PageNum: params.PageNum,
        PageSize: params.PageSize,
        KeyWord: params.KeyWords,
        langType: params.langType,
        PublishDate: params.PublishDate
      }
    }
  })
}

export function deleteBtcReport(params) {
  return request({
    url: '/DeleteBtcReport',
    method: 'post',
    headers: {
      'Authorization': getToken()
    },
    data: {
      MessageType: 112,
      MessageID: btcguid(),
      Data: {
        FileID: params.FileID,
        FilePath: params.FilePath
      }
    }
  })
}

export function addBeefBulletin(params) {
  return request({
    url: '/AddBeefBulletin',
    method: 'post',
    headers: {
      'Authorization': getToken()
    },
    data: {
      MessageType: 113,
      MessageID: btcguid(),
      Data: {
        langType: params.Type,
        PublishDate: params.PublishDate,
        UpdateTime: params.UpdateTime,
        FilePath: params.FilePath,
        BulletinTitle: params.BulletinTitle
      }
    }
  })
}

export function updateBtcReport(params) {
  return request({
    url: '/UpdateBtcReport',
    method: 'post',
    headers: {
      'Authorization': getToken()
    },
    data: {
      MessageType: 19000010,
      MessageID: btcguid(),
      Data: {
        FileID: params.FileID,
        langType: params.Type,
        PublishDate: params.PublishDate,
        UpdateTime: params.UpdateTime,
        FilePath: params.FilePath,
        BulletinTitle: params.BulletinTitle
      }
    }
  })
}



// WEBPACK FOOTER //
// ./src/api/btcreport.js